import { api } from "./apiClient";
import { ROIPEntry } from "@/types/roip";

export const roipService = {
  getAll: (ownerId?: string) => {
    const params = ownerId ? `?owner_id=${ownerId}` : '';
    return api.get<ROIPEntry[]>(`/roips/${params}`);
  },
  getById: (id: string) => api.get<ROIPEntry>(`/roips/${id}`),
  create: (payload: { roi: string; ownerID: string; userName: string }) => 
    api.post<ROIPEntry>(`/roips/?owner_id=${payload.ownerID}&user_name=${encodeURIComponent(payload.userName)}`, { roi: payload.roi }),
  update: (id: string, payload: Partial<ROIPEntry>) => 
    api.put<ROIPEntry>(`/roips/${id}`, payload),
  toggleFechaDictaminacion: (id: string, enabled: boolean, ownerId: string, userName: string) =>
    api.put<ROIPEntry>(`/roips/${id}/toggle-fecha-dictaminacion?enabled=${enabled}&owner_id=${ownerId}&user_name=${encodeURIComponent(userName)}`, {}),
  toggleFechaReporteSITI: (id: string, enabled: boolean, ownerId: string, userName: string) =>
    api.put<ROIPEntry>(`/roips/${id}/toggle-fecha-reporte-siti?enabled=${enabled}&owner_id=${ownerId}&user_name=${encodeURIComponent(userName)}`, {}),
  delete: (id: string) => api.delete<{ message: string; id: string }>(`/roips/${id}`),
};
